<template>
  <div class="footers">
    <el-row class="footers-con" type="flex" justify="flex-start">
      <div class="left">
        <img
          class="left-logo"
          src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-saas-pc/sdjzmh/footerlogo.png"
          alt=""
        />
        <!-- <div class="foot-w">山东家政助力家政行业提质扩容</div> -->
      </div>
      <div class="right">
        <div class="top_row">
          <p style="margin-right: 80px">
            地址：北京市西城区北三环中路23号燕莎盛世大厦
          </p>
          <p>邮编：100000</p>
        </div>

        <p style="margin-bottom: 0">技术支持：伟东国信科技（北京）有限公司</p>
      </div>
      <div class="h5qrcode_box">
        <div class="h5qrcode_wrap">
          <div id="qrcode"></div>
        </div>

        <span class="txt">扫码查看h5端</span>
      </div>
    </el-row>
    <div class="bottom-text">
      <a class="txt" href="https://beian.miit.gov.cn" target="_blank"
        >京ICP备2021025972号-1</a
      >
    </div>
    <!-- <el-row class="footers-f">
         <span>版权所有： 伟东国信</span>
         <span>技术支持：伟东云教育</span>
     </el-row> -->
    <!-- <saas-nsr-footer :textColor="'#363636'" :bgColor="'#EAEAEA'"/> -->
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
export default {
  name: "footers",
  props: {},
  data() {
    return {
      QRCode: null,
    };
  },

  methods: {
    async qrcode() {
      if (this.QRCode) return;
      let domainArr = localStorage.getItem("domain");
      let domainUrl =
        domainArr &&
        JSON.parse(domainArr).find((item) => item.frontend_template_id == 4)
          .domain;
      this.QRCode = new QRCode("qrcode", {
        width: 106,
        height: 106, // 高度
        text: `https://${domainUrl || "wdgxjz-h5.fat.wdeduc.com"}`, // 二维码内容
        display: "none",
        // render: 'canvas' ,   // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
        // background: '#f0f',   // 背景色
        // foreground: '#ff0'    // 前景色
      });
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.qrcode();
    });
  },
};
</script>
<style lang="stylus" scoped>
@import '../../asset/css/footers.styl';
</style>
